export default function normalizarTitulo(texto) {
  if (!texto) return '';

  // Lista de palavras que devem permanecer em minúsculo (exceto se forem a primeira da frase)
  const excecoes = [
    'de', 'do', 'da', 'dos', 'das', 'e', 'em', 'com', 
    'para', 'por', 'o', 'a', 'os', 'as', 'um', 'uma', 'ao'
  ];

  return texto
    .trim()
    .replace(/[.,!?;:()''`´]/g, '') // Remove pontuação
    .replace(/\s+/g, ' ')           // Remove espaços extras
    .toLowerCase()
    .split(' ')
    .map((palavra, index) => {
      // Se for a primeira palavra da frase, SEMPRE fica com a primeira letra maiúscula
      if (index === 0) {
        return palavra.charAt(0).toUpperCase() + palavra.slice(1);
      }

      // Se a palavra estiver na lista de exceções, mantém minúscula
      if (excecoes.includes(palavra)) {
        return palavra;
      }

      // Para as demais palavras, aplica a primeira letra maiúscula
      return palavra.charAt(0).toUpperCase() + palavra.slice(1);
    })
    .join(' ');
}